/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { GRAPHQL_ENV } from '../../../gql';
import WyngModule from '../../ContentTypeComponents/Wyng/Wyng';
import findCategoryPageByURL from '../../../gql/queries/findCategoryPageByURL';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import useExperimentServiceAttributes from '../../../helpers/experimentService/useExperimentServiceAttributes';

const GraphqlWyngStaticPage = ({ brand, page }) => {
    const { targeting, context, isGraphqlTargetingEnabled } = useExperimentServiceAttributes({ queryName: 'findCategoryPageByUrl' });
    const WYNG_PAGE_QUERY = findCategoryPageByURL(isGraphqlTargetingEnabled, brand.domain, page?.path, page?.contentType);

    const { loading, error, data } = useQuery(WYNG_PAGE_QUERY, {
        variables: {
            ...(isGraphqlTargetingEnabled ? { targeting } : {}),
        },
        context,
    });

    if (loading) {
        return <div style={{ height: '80vh' }} />;
    }

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: WYNG_PAGE_QUERY,
            component: 'GraphqlWyngStaticPage.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }

    if (!data) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: WYNG_PAGE_QUERY,
            component: 'GraphqlWyngStaticPage.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
        return null;
    }

    const wyngData = data?.findCategoryPageByUrl?.content?.entries?.[0];
    return (
        <>
            {wyngData?.seo && <GraphqlSeoHeadTags seoData={wyngData.seo} />}
            <WyngModule data={wyngData} />
        </>
    );
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

GraphqlWyngStaticPage.propTypes = {
    brand: object.isRequired,
    page: object.isRequired,
};

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(GraphqlWyngStaticPage);
